module.exports = __webpack_public_path__ + "static/requests-banner-7e7fc98bf1de94704f16746ec41a005d.png";